module.exports = __webpack_public_path__ + "img/product-showcase-gallery-05.e0e6c94e.jpg";